exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".your-quote-heading-multi-vehicle[data-v-4ac529a7]{display:block}@media (min-width:389px){.your-quote-heading-multi-vehicle[data-v-4ac529a7]{display:inline-block}}", ""]);

// exports
